@if (chips().length === 0) {
  <p class="worker-tag-picker__empty">{{ 'No worker tags' | translate }}</p>
} @else {
  <div class="worker-tag-picker" role="group">
    @for (chip of chips(); track chip.value) {
      <button
        type="button"
        class="worker-tag-chip"
        [class.worker-tag-chip--on]="chip.selected"
        [disabled]="disabled()"
        [attr.aria-pressed]="chip.selected"
        (click)="toggle(chip.value)"
      >{{ chip.label }}</button>
    }
  </div>
}
